import { render, staticRenderFns } from "./CreateRelated.vue?vue&type=template&id=91457610&scoped=true&"
import script from "./CreateRelated.vue?vue&type=script&lang=js&"
export * from "./CreateRelated.vue?vue&type=script&lang=js&"
import style0 from "./CreateRelated.vue?vue&type=style&index=0&id=91457610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91457610",
  null
  
)

export default component.exports